export default function hasNonUndefinedProperty <T>(obj: T): boolean {
  for (const key in obj) {
    if (obj[key] !== undefined) {
      return true; // Exit early as soon as a valid property is found
    }
  }
  return false;
};
